import React, { useEffect } from "react";
import SwiperCore, { Navigation, Pagination, Mousewheel } from "swiper";
import Image from "components/image";
import RichText from "components/rich-text";
import Money from "components/money";
import RenderAccordions from "../product/details/accordions";
import PaymentIcons from "components/payment-icons";
import { Swiper, SwiperSlide } from "components/swiper";
import ReviewsSnippet from "components/reviews-snippet";
import AddToCart from "components/add-to-cart";
import { useGlobalContext } from "context/global";
import DeliveryFrequencies from "components/delivery-frequencies";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionQuantityInput from "components/subs-quantity-input";
import extractIdFromGid from "helpers/extract-gid";
import { formatTitle } from "helpers/format-title";
import { selectAndSaveFrequency } from "actions/cart";
import PricePerKg from "components/price-per-kg";

SwiperCore.use([Pagination, Navigation, Mousewheel]);

const ProductBundle = ({ data }) => {
	const {
		showReviews, bundle, offerPrice, bundlePrice, pricePerMeal, buttonText, isSubscriptionBundle, hidePrice, defaultFrequency
	} = data;
	const { translation, paymentIcons, cartSettings: { subscription: { frequencies } } } = useGlobalContext();
	const { subscriptionId } = useSelector((state) => state.account.subscription);
	const dispatch = useDispatch();
	const subButtonBgColor = data.subButtonBgColor?.hex;
	const title = data.title || bundle.title;
	const images = data.images || bundle.images;
	const description = data.description || bundle.description;

	const controls = {
		modules: [Pagination],
		slidesPerView: 1,
		preventClicks: true,
		preventClicksPropagation: false,
		freeMode: true,
		spaceBetween: 10,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-pb",
			prevEl: ".left-arrow-pb",
		},
		pagination: {
			clickable: true,
			el: ".swiper-pagination",
			type: "bullets",
		},
		a11y: true,
	};

	useEffect(() => {
		// Change the default frequency for product bundles
		if (defaultFrequency) {
			const frequency = frequencies.find(f => f.intervalCount === defaultFrequency && f.interval === "WEEK");
			frequency && dispatch(selectAndSaveFrequency(frequency));
		}
	}, []);

	if (isSubscriptionBundle && !subscriptionId) return null;

	return (
		<div className="w-90 m-auto flex flex-col lg:flex-row justify-between my-10 gap-x-10 hd-screen-max-width product-bundle">
			<div className="lg:w-[47%] w-full my-2 relative">
				<Swiper {...controls}>
					{images?.map((i) => (
						<SwiperSlide key={i._key}>
							<Image image={i.asset} alt={i.alt} />
						</SwiperSlide>
					))}
					<div className="swiper-pagination"></div>
				</Swiper>

			</div>

			<div className="flex flex-col md:mt-2 mt-4 lg:w-[47%] w-full md:sticky md:h-full">
				<h1 className="text-h2">{formatTitle(title)}</h1>
				{showReviews && <ReviewsSnippet leftAlign />}

				{!isSubscriptionBundle && !hidePrice &&
					<>
						<div className="flex flex-row items-center">
							{offerPrice && <div className="pr-4 text-lg font-boldParagraph">
								<Money value={offerPrice} />
							</div>}
							{bundlePrice &&
								<div
									className="md:pr-6 pr-4 text-lg line-through"
									role="text"
									aria-label={`Original price: ${bundlePrice}`}
								>
									<Money value={bundlePrice} />
								</div>}
							{!offerPrice && !bundlePrice && <div className="pr-4 text-lg font-bold">
								<Money value={bundle.variant.price} />
							</div>}
							{pricePerMeal && <div className="bg-[#C2C367] rounded-2xl py-1 px-4 font-light">
								{pricePerMeal}
							</div>}


						</div>
						<PricePerKg price={offerPrice || bundlePrice} weight={bundle.weight} />
						<span className=" text-gray-500 mb-3 text-xs">
							{translation.other?.freeShipping}
						</span>
					</>}
				<div id="trial-bundle-offer">
					<div className="my-3">
						<RichText value={description} />
					</div>
					{!isSubscriptionBundle && (
						<>
							{!bundle?.sellingPlanId && (
								<div>
									<p className="font-bold pb-2 pt-4">
										{translation.other?.selectDeliveryFrequency}
									</p>
									<DeliveryFrequencies hideFrequencies={[8]} dropdown />
								</div>
							)}

							<div className="w-full md:w-fit flex my-3 justify-start">
								<AddToCart product={bundle} openCart
									className="py-4 mt-1.5 px-8 w-full btn-orange !text-xs"
									text={buttonText} />
							</div>
						</>
					)}

					{isSubscriptionBundle &&
						<SubscriptionQuantityInput
							product={bundle}
							stock={bundle.variant.stock}
							productVariantId={extractIdFromGid(bundle.variant.id)}
							addClassName="!py-4 !px-8 !md:w-fit !btn-orange"
							containerClass="md:!justify-start mb-3"
							bgColor={subButtonBgColor}
						/>
					}
				</div>
				<p className="text-gray-500 text-sm">{translation.other?.checkoutMessage}</p>
				{paymentIcons?.length && <PaymentIcons data={paymentIcons} settings={true} />}
				<div className="pb-10 pt-2.5">
					<RenderAccordions accordions={data?.accordions} />
				</div>
			</div>
		</div>
	);
};

export default ProductBundle;